import { render, staticRenderFns } from "./OfferView1.vue?vue&type=template&id=48fe5f68&scoped=true"
import script from "./OfferView1.vue?vue&type=script&lang=js"
export * from "./OfferView1.vue?vue&type=script&lang=js"
import style0 from "./OfferView1.vue?vue&type=style&index=0&id=48fe5f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fe5f68",
  null
  
)

export default component.exports